import { environment } from '../../../environments/environments';

export const apiUrl = (url: string): string => {
  const baseUrl = environment.apiBaseUrl.replace(/\/+$/, '');
  return `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`;
};

export const directApiOrigin = (): string => '';

export const shouldRetryAgainstApiServer = (_error: unknown): boolean => false;
